import GMap from './GMap';

export default GMap;